<template>
  <AppTooltip :disabled="!exportDisabled">
    <template #activator="{ props }">
      <!-- We use a wrapper div to retain the disable styling _and_ the tooltip hover event -->
      <div v-bind="props">
        <app-button class="poly-office-export-button"
                    :disabled="exportDisabled"
                    @click="handleClick"
                    type="ghost"
                    variant="neutral">
          <template #left-icon>
            <app-icon-poly-office />
          </template>
          {{ $t('common.polyOffice.PolyOfficeMultiSelectBarButtonExport.exportFiles') }}
        </app-button>
      </div>
    </template>
    <span>{{ $t('common.polyOffice.exportLimitTooltip') }}</span>
  </AppTooltip>
</template>

<script>
import AppTooltip from '@/common/AppTooltip.vue'

import { isPolyOfficeExportDisabled } from './exportability'

export default {
  name: 'PolyOfficeMultiSelectBarButtonExport',
  components: {
    AppTooltip,
  },
  props: {
    fileSizes: {
      type: Array,
      required: true,
    },
  },
  computed: {
    exportDisabled () {
      return isPolyOfficeExportDisabled(this.fileSizes)
    },
  },
  methods: {
    handleClick () {
      this.$emit('polyOfficeOpenDialog')
    },
  },
}
</script>

<style scoped lang="scss">
.poly-office-export-button:disabled {
  :deep(.app-icon-poly-office) {
    // Match Vuetify list item disabled opacity used in app menus.
    opacity: 0.6;
  }
}
</style>
